import ProfileModel from "../../../../Profile/Models/ProfileModel";

export default class EitherOrResultsStandingsModel {
  public userId: string = "";
  public userModel: ProfileModel = null;
  public personalBest: string = "";
}
